<template>
<div class="flex min-h-screen bg-gray-50 dark:bg-gray-900">

<!-- Sidebar -->
<HrSidebar :isOpen="isSidebarOpen"/>

<main class="flex-1 transition-all duration-300" :class="{'ml-64':isSidebarOpen,'ml-0':!isSidebarOpen}">

<!-- Topbar -->
<header class="fixed top-0 w-full z-50 bg-white dark:bg-gray-800 shadow">
<HrTopbar
:page-title="currentPageTitle"
:is-sidebar-open="isSidebarOpen"
:is-dark-mode="isDarkMode"
@toggle-sidebar="toggleSidebar"
@toggle-dark-mode="toggleDarkMode"
/>
</header>

<div class="p-6 mt-16">

<!-- Search + Button -->
<div class="flex justify-between mb-8 p-4">

<input
v-model="search"
type="text"
placeholder="Search section..."
class="border rounded-lg px-4 py-2 w-72 dark:bg-gray-700 dark:text-white"
/>

<button
@click="openModal"
class="bg-[#74bd54] text-white px-5 py-2 rounded-lg hover:bg-[#63a43f]"
>
+ Add Section
</button>

</div>

<!-- Section Grid -->
<div v-if="filteredSections.length" class="grid md:grid-cols-3 lg:grid-cols-4 gap-6">

<div
v-for="section in filteredSections"
:key="section.id"
class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow hover:shadow-lg"
>

<div class="flex items-center space-x-3 mb-4">

<div class="w-12 h-12 bg-secondary text-white flex items-center justify-center rounded-full font-bold">
{{ section.code }}
</div>

<div>
<h3 class="font-semibold text-gray-800 dark:text-white">
{{ section.name }}
</h3>

<span class="text-xs text-gray-500">
School Section
</span>
</div>

</div>

<p class="text-sm text-gray-500 mb-6">
{{ section.description }}
</p>

<div class="flex justify-between text-sm">

<button
@click="editSection(section)"
class="text-blue-600 hover:underline"
>
Edit
</button>

<button
@click="deleteSection(section.id)"
class="text-red-500 hover:underline"
>
Delete
</button>

</div>

</div>

</div>

<div v-else class="text-center text-gray-400 mt-20">
No sections created yet
</div>


<!-- Modal -->

<Transition name="modal">
<div
v-if="showModal"
class="fixed inset-0 bg-black/40 flex items-center justify-center"
>

<div class="bg-white dark:bg-gray-800 rounded-xl p-6 w-[420px]">

<h3 class="text-lg font-semibold text-[#035a76] mb-6">
{{ editing ? "Edit Section" : "Create Section" }}
</h3>

<form @submit.prevent="saveSection" class="space-y-4">

<input
v-model="form.name"
type="text"
placeholder="Section Name"
required
class="w-full border rounded p-2 dark:bg-gray-700 dark:text-white"
/>

<input
v-model="form.code"
type="text"
placeholder="Code (NUR, PRI...)"
required
class="w-full border rounded p-2 dark:bg-gray-700 dark:text-white"
/>

<textarea
v-model="form.description"
placeholder="Description"
class="w-full border rounded p-2 dark:bg-gray-700 dark:text-white"
></textarea>

<div class="flex justify-end space-x-3">

<button
type="button"
@click="closeModal"
class="px-4 py-2 bg-gray-300 rounded"
>
Cancel
</button>

<button
type="submit"
class="px-4 py-2 bg-[#74bd54] text-white rounded hover:bg-[#63a43f]"
>
Save
</button>

</div>

</form>

</div>

</div>
</Transition>

</div>

</main>
</div>
</template>

<script setup>

import {ref,computed, onMounted} from "vue"
import api from "@/services/api"
import HrSidebar from "@/components/hr/HrSidebar.vue"
import HrTopbar from "@/components/hr/HrTopbar.vue"

const currentPageTitle = ref("Sections")

const isSidebarOpen = ref(true)
const isDarkMode = ref(false)

const showModal = ref(false)
const editing = ref(false)

const search = ref("")

const sections = ref([])

// const sections = ref([
// {
// id:1,
// name:"Nursery",
// code:"NUR",
// description:"Early childhood education"
// },
// {
// id:2,
// name:"Primary",
// code:"PRI",
// description:"Primary school level"
// },
// {
// id:3,
// name:"Junior High",
// code:"JHS",
// description:"Junior high school level"
// }
// ])

const fetchSections = async () => {
  try{
    const response = await api.get("Sections.php");
    sections.value = response.data.map(section => ({
      id:section.id,
      name:section.name,
      code:section.code,
      description:section.description
    }));

  } catch (error) {
    console.error("Error fetching Sections:", error);
  }
};

const form = ref({
id:null,
name:"",
code:"",
description:""
})

const filteredSections = computed(()=>{
return sections.value.filter(s=>
s.name.toLowerCase().includes(search.value.toLowerCase())
)
})

const openModal=()=>{
editing.value=false
form.value={id:null,name:"",code:"",description:""}
showModal.value=true
}

const editSection=(section)=>{
editing.value=true
form.value={...section}
showModal.value=true
}

// const saveSection=()=>{

// if(editing.value){

// const index=sections.value.findIndex(s=>s.id===form.value.id)
// sections.value[index]={...form.value}

// }else{

// sections.value.push({
// id:Date.now(),
// ...form.value
// })

// }

// closeModal()

// }

const saveSection = async () =>{
  try{
  let response;

  if(editing.value){
    response = await api.put("Sections.php", form.value)
    const index = sections.value.findIndex(d => d.id === form.value.id)
      if (index !== -1) {
        sections.value[index] = { ...form.value };
      }
      
  }else{
        response = await api.post("Sections.php", form.value)
        sections.value.push({
          id:response.data.id,
          name:response.data.name,
          code:response.data.code,
          description:response.data.description
        });
      }
closeModal();

  } catch (error) {
    console.error("Error saving section:", error);
  }
};

// const deleteSection=(id)=>{
// sections.value=sections.value.filter(s=>s.id!==id)
// }

const deleteSection = async (id) => {
try {

    await api.delete("Sections.php", {
      data: { id: id }
    });

    sections.value = sections.value.filter(u => u.id !== id);

  } catch (error) {
    console.error("Error deleting section:", error);
  }
}

const closeModal=()=>{
showModal.value=false
}

const toggleSidebar=()=>{
isSidebarOpen.value=!isSidebarOpen.value
}

const toggleDarkMode=()=>{
isDarkMode.value=!isDarkMode.value

if(isDarkMode.value){
document.documentElement.classList.add("dark")
}else{
document.documentElement.classList.remove("dark")
}

}

onMounted(() => {
    fetchSections();
})

</script>

<style>

.modal-enter-active,
.modal-leave-active{
transition:all .25s ease;
}

.modal-enter-from{
opacity:0;
transform:scale(.9);
}

.modal-leave-to{
opacity:0;
transform:scale(.9);
}

</style>